import { z } from "zod";

/**
 * AUD is the site's currency; USD is accepted for legacy records during migration.
 */
export const currencySchema = z.enum(["AUD", "USD"]);
export type Currency = z.infer<typeof currencySchema>;

export const DEFAULT_CURRENCY: Currency = "AUD";

/**
 * A monetary amount in integer minor units (cents). Prices are never floats —
 * dollars↔cents conversion happens only at the UI edge.
 */
export const priceCentsSchema = z
  .number()
  .int("price must be a whole number of cents")
  .nonnegative("price cannot be negative")
  .max(1_000_000_000, "price is unreasonably large"); // $10,000,000 ceiling guards typos

/** Format integer minor units as a localized currency string (1999 -> "$19.99"). */
export function formatMoney(cents: number, currency: Currency = DEFAULT_CURRENCY): string {
  const formatted = new Intl.NumberFormat("en-AU", { style: "currency", currency }).format(cents / 100);
  return currency === "AUD" ? formatted.replace("$", "A$") : formatted;
}
